module.exports = __webpack_public_path__ + "img/icon_map_huanjingjiankong_lixian.2454ec1b.svg";